import { ContactInfo } from '@/shared/interfaces/ContactInfo'
import { GroupInfo } from '@/shared/interfaces/GroupInfo'
import { User } from '@/shared/interfaces/User'

export function chatsGetAvatar(chat: {
  user?: User;
  contact?: ContactInfo;
  group_info?: GroupInfo;
}): string | undefined {
  if (chat?.group_info) {
    return chat.group_info.avatar
  }

  if (chat?.contact?.avatar) {
    return chat.contact.avatar
  }

  if (chat?.user?.avatar) {
    return chat.user.avatar
  }

  return undefined
}
